import { z } from "zod";
import { TimestampSchema } from "./common.js";
import { TokenUsageSchema } from "./engine.js";
import { IdSchema } from "./ids.js";
import { EffortLevelSchema } from "./model-policy.js";
/** One recorded cost (DESIGN §6). `usd` is always a delta, never a cumulative total. */
export const CostEntrySchema = z.object({
    id: IdSchema,
    at: TimestampSchema,
    companyId: IdSchema,
    connectionId: IdSchema,
    runId: IdSchema,
    taskId: IdSchema.nullable(),
    agentId: IdSchema.nullable(),
    sessionId: z.string().nullable(),
    usd: z.number().nonnegative(),
    notional: z.boolean(),
    byModel: z.record(z.string(), TokenUsageSchema),
    /** The model and effort the run was resolved to (absent on older entries). */
    model: z.string().optional(),
    effort: EffortLevelSchema.optional(),
});
//# sourceMappingURL=ledger.js.map